<template>
  <div>
    <ChangePasswordForm :show="!!oobCode" :oobCode="oobCode" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "@vue/composition-api";
import { getAuth, verifyPasswordResetCode } from "firebase/auth";
import ChangePasswordForm from "@/components/Common/ChangePasswordForm.vue";

export default defineComponent({
  name: "ResetPasswordView",
  async mounted() {
    const oobCode = this.$route.query.oobCode as string;
    if (!oobCode) {
      this.$router.push({
        name: "Sign In",
        params: {
          snackbarAction: "true",
          snackbarText: String(this.$t("signIn.invalidResetLink")),
          snackbarColor: "pink",
        },
      });
      return;
    }
    try {
      await verifyPasswordResetCode(getAuth(), oobCode);
      this.oobCode = oobCode;
    } catch (error) {
      console.error(error);
      this.$router.push({
        name: "Sign In",
        params: {
          snackbarAction: "true",
          snackbarText: String(this.$t("signIn.invalidResetLink")),
          snackbarColor: "pink",
        },
      });
    }
  },
  components: {
    ChangePasswordForm,
  },
  data() {
    return {
      oobCode: "",
    };
  },
});
</script>
